export default {"src":"/_next/static/media/BicycleIconGreen.34cfe711.svg","height":43,"width":62,"blurWidth":0,"blurHeight":0};